<template>
    <DForm>
        <DFormRow
            :label="$t('roles.field_name')"
            :is-vertical="true"
        >
            <DInput
                v-model="form.name"
                :invalid-feedback="errors.name"
                maxlength="255"
            />
        </DFormRow>
        <DFormRow
            :label="$t('roles.field_permissions')"
            :is-vertical="true"
        >
            <DInput
                v-model="permission_search"
                :invalid-feedback="errors.permissions"
                :placeholder="$t('roles.search_permissions_placeholder')"
                maxlength="255"
                class="mb-3"
            />
            <DTable
                :fields="fields"
                :items="filteredPermissions"
            >
                <template #checkbox="{item}">
                    <td>
                        <DFormCheck
                            v-model="item.checked"
                            @change="togglePermission(item.permission)"
                        />
                    </td>
                </template>
                <template #permission="{item}">
                    <td>
                        {{ item.permission }}
                    </td>
                </template>
            </DTable>
        </DFormRow>
        <DFormControls
            :dirty="form.isDirty"
            :cancel-route="$route('roles.index')"
            @submit="saveRole"
        />
    </DForm>
</template>

<script>
import { useForm } from '@inertiajs/vue3'

export default {
    name: 'RoleForm',
    props: {
        availablePermissions: {
            type: Array,
            default: () => { return [] }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        role: {
            type: Object,
            default () { return { permissions: [] } }
        }
    },
    emits: ['saveRole'],
    data () {
        return {
            fields: [
                { key: 'checkbox', label: '', sorter: false },
                { key: 'permission', label: this.$t('roles.field_permissions'), sorter: true }
            ],
            form: useForm({
                name: this.role?.name,
                permissions: this.role.permissions
                    ? this.role.permissions.map(
                        permission => permission.name
                    )
                    : []
            }),
            permission_search: ''
        }
    },
    computed: {
        filteredPermissions () {
            return this.availablePermissions
                .map(({ value }) => ({ permission: value, checked: this.form.permissions.includes(value) }))
                .filter(({ permission }) => permission.includes(this.permission_search))
        }
    },
    methods: {
        togglePermission (perm) {
            if (this.form.permissions.includes(perm)) {
                this.form.permissions.splice(this.form.permissions.indexOf(perm), 1)

                return
            }
            this.form.permissions.push(perm)
        },
        saveRole () {
            this.$emit('saveRole', this.form)
        }
    }
}
</script>

<style lang="scss" scoped>
.roleTag {
    display: inline-block;
    justify-self: flex-start;
    background: var(--colorSecondaryLight);
    color: var(--colorPrimaryText);
    border-radius: 5px;
    font-size: 12px;
    margin: 2px 5px;
    padding: 5px 10px;
}
</style>
